import { Injectable, Inject, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, interval } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ConnectionStatusConfig } from '../models/connection-status-config';
import { CONNECTION_STATUS_CONFIG } from '../injection-tokens/connection-status-config.token';

@Injectable({
  providedIn: 'root'
})
export class NgxConnectionStatusService {

  private statusHook$: Observable<boolean>;

  constructor(@Inject(CONNECTION_STATUS_CONFIG) private config: ConnectionStatusConfig, private http: HttpClient) {
    if (!config.checkInterval) {
      config.checkInterval = 5000;
    }
    this.initConnectionCheck(config.checkInterval);
  }

  private initConnectionCheck(_interval: number = 5000) {
    let url = `//${window.location.hostname}`;
    if (window.location.port) {
      url += `:${window.location.port}`;
    }
    url += `?${Math.random()}`;
    this.statusHook$ =
      interval(_interval)
      .pipe(
        switchMap(() => {
          if (isDevMode()) {
            return this.http.get<boolean>(url)
            .pipe(
              map(() => {
                return true;
              }), catchError(this.handleError())
            );
          } else {
            return this.http.head<boolean>(url)
            .pipe(
              map(() => {
                return true;
              }), catchError(this.handleError())
            );
          }
        })
      );
  }

  private handleError() {
    return (error: any): Observable<boolean> => {
      let isOnline = false;
      if (error.status == 304 || (error.status >= 200 && error.status < 300)) {
        isOnline = true;
      }
      return of(isOnline);
    };
  }

  public statusHook() {
    return this.statusHook$;
  }
}
